import store from '@/store/store';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  CAMPAGNE,
  DEMANDE_IMPRESSION,
  DEMANDE_INTERVENTION,
  LISTE_MODULE_TAG_TYPE,
} from '@/configuration/parametrage/tagConf';

export async function getListModuleTagType() {
  await store.dispatch('parametres/loadParametresInterne', [
    PARAMETRES_INTERNE_KEYS.campagne.key,
    PARAMETRES_INTERNE_KEYS.demandeImpression.key,
  ]);

  const parametresInterne = store.getters['parametres/parametresInterne'];

  return LISTE_MODULE_TAG_TYPE.filter(tagModule => {
    switch (tagModule.code) {
      case CAMPAGNE:
        return parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key);
      case DEMANDE_IMPRESSION:
      case DEMANDE_INTERVENTION:
        return parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
      default:
        return true;
    }
  });
}

export function chooseTagType(tag) {
  if (!tag.actif) {
    return 'striped-background has-text-weight-bold mgr-2';
  }
  if (!tag.couleur) {
    return 'is-primary has-text-white mgr-2';
  }
  return 'has-text-white mgr-2';
}
